import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "./context";
import { SnackbarProvider } from "./components/Utils/SnackbarContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(

  <BrowserRouter>
    <MaterialUIControllerProvider>
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>

);
